export default __webpack_public_path__ + "static/header-39378811316d74b7881cfcda9f2d8c56.png";